import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { ScheduleTimeComponent } from '../components/schedule-time/schedule-time.component';

@Injectable({
  providedIn: 'root',
})
export class ProviderAbsenceSchedulerDialogService {
  constructor(private dialogService: DialogService) {}

  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: ScheduleTimeComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: ScheduleTimeComponent,
      height: '800px',
      width: '1200px',
      cssClass: 'schedule-meeting provider-absence-scheduler',
    });

    const content: ComponentRef<ScheduleTimeComponent> =
      dialog.content as ComponentRef<ScheduleTimeComponent>;
    const instance: ScheduleTimeComponent = content.instance;

    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
